import {
  Component,
  Input,
  EventEmitter,
  Output,
  OnChanges,
  SimpleChanges,
} from '@angular/core';
import { LoggedInUserInfo } from '@app/user-entity/logged-in-user-info.interface';
import { Subject } from 'rxjs';
import { DateRange, MenuItem } from '../models/shared.model';

@Component({
  selector: 'app-custom-range-presets',
  template: `
    <div ngbDropdown class="d-inline-block role-dropdown">
      <button
        [ngClass]="{ error: inError }"
        class="btn btn-dropdown dark-text role-width"
        id="dropdownCategory"
        ngbDropdownToggle
      >
        {{ selectedOption.caption }}
        <i class="icon icon-down-arrow"></i>
      </button>
      <div
        ngbDropdownMenu
        aria-labelledby="dropdownCategory"
        class="dropdownMenu"
      >
        <ng-container *ngFor="let item of dateRangeOptions">
          <button
            ngbDropdownItem
            class="dropdown-item dropdown-value"
            (click)="onSelect(item)"
            *ngIf="item.value !== selectedOption.value"
          >
            <div class="dropdown-text">{{ item.caption }}</div>
          </button>
        </ng-container>
      </div>
    </div>
  `,
  styles: [
    `
      #dropdownCategory {
        background: #fff;
        margin-right: 0;
        margin-left: 0;
        width: 100%;
        position: relative;
        font-size: 0.875em;
        color: #141d24;
        border-radius: 4px;
      }
      #dropdownCategory.error {
        border: 1px solid red;
      }
      .dropdown-item:disabled {
        cursor: not-allowed;
        opacity: 0.65;
        pointer-events: all;
      }
      .dropdown-toggle {
        padding-right: 1em;
        width: auto;
      }
      .dropdown-toggle i {
        padding-top: 0.2em;
        padding-left: 0.5em;
      }
      .dropdown-toggle::after {
        display: none;
      }
    `,
  ],
})
export class CustomRangePresetsComponent implements OnChanges {
  @Output() onChangeDropdown = new EventEmitter();
  @Input() isLabelVisible = false;
  @Input() inError = false;
  @Input() dateRange: DateRange;
  dateRangeOptions = [
    { caption: 'Last 7 Days', value: '7' },
    { caption: 'Last 30 Days', value: '30' },
    { caption: 'Custom Range', value: 'customrange' },
  ];

  selectedOption = this.dateRangeOptions[0];
  loggedInUserInfo: LoggedInUserInfo;
  destroy$: Subject<boolean> = new Subject<boolean>();

  ngOnChanges(changes: SimpleChanges) {
    if (changes.dateRange) {
      this.updateSelectedOption(changes.dateRange.currentValue);
    }
  }

  updateSelectedOption(dateRange: DateRange) {
    if (!dateRange) return;

    const today = new Date();
    const isTillToday = dateRange.end?.toDateString() === today.toDateString();

    if (isTillToday) {
      const diffDays = this.calculateDateDifference(
        dateRange.start,
        dateRange.end
      );
      this.selectedOption =
        this.dateRangeOptions.find(
          (option) => option.value === diffDays.toString()
        ) || this.getCustomRangeOption();
    } else {
      this.selectedOption = this.getCustomRangeOption();
    }
  }

  /**
   * Calculates the difference in days between two dates.
   * @param start - The start date.
   * @param end - The end date.
   * @returns The number of days between the start and end dates.
   */
  calculateDateDifference(start: Date, end: Date): number {
    const diffTime = Math.abs(
      new Date(end).getTime() - new Date(start).getTime()
    );

    const MILLISECONDS_IN_A_DAY = 1000 * 60 * 60 * 24;
    return Math.floor(diffTime / MILLISECONDS_IN_A_DAY);
  }

  getCustomRangeOption() {
    return this.dateRangeOptions.find(
      (option) => option.value === 'customrange'
    );
  }

  onSelect(item: MenuItem) {
    this.selectedOption = item;
    this.onChangeDropdown.emit(item);
  }
}
